<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import api from '../../api/analytics/index';
import selectedPatient from '../../store/selectedPatient';


export default {
  name: 'AnalyticsList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron
  },
  data() {
    return {
      analytics: [],
      targetUserId: selectedPatient.get(),
      breadcrumb: [
        {link: '/workspace', name: 'Workspace'},
        {link: '', name: this.$t('health.analytics.list.title'), disabled: true}
      ]
    };
  },
  created() {
    this.fetchAnalytics();
  },
  methods: {
    fetchAnalytics() {
      const request = this.targetUserId
        ? api.getAnalytics(this, this.targetUserId)
        : api.getAllAnalytics(this);
      request
        .then(response => {
          this.analytics = response;
        })
        .catch(error => {
          console.error("Error fetching analytics", error);
        });
    },
    formatDate(dateValue) {
      if (!dateValue) return '';
      const date = new Date(dateValue * 1000);
      return date.toLocaleDateString();
    },
    goToCategories(id, ownerUserId) {
      const targetUserId = this.targetUserId || ownerUserId;
      this.$router.push({
        name: 'ListOfCategories',
        params: { analyticId: id },
        query: targetUserId && targetUserId !== this.targetUserId ? { targetUserId } : {}
      });
    },
    goToImportReport(id) {
      this.$router.push({
        name: 'ImportReport',
        params: { analyticId: id }
      });
    }
  }
};
</script>

<template>
  <main-layout controlsBg="light" :hasControlsBar="false" :breadcrumb="breadcrumb">
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="8">
          <div id="header">
            <h1 class="header-title">
              <chevron @click="$router.push({name: 'Workspace'})"/>
              {{ $t('health.analytics.list.title') }}
            </h1>
          </div>
        </grid-col>
      </grid-row>

      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="8">
          <div class="analytics-list">
            <table class="analytics-table">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>{{ $t('health.analytics.list.date') }}</th>
                  <th>{{ $t('health.analytics.list.notes') }}</th>
                  <th class="action-header" v-has-feature="'Superadmin'">Informe</th>
                  <th class="action-header">Resultados</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="analytic in analytics" :key="analytic.id" class="clickable-row">
                  <td @click="goToCategories(analytic.id, analytic.userId)">{{ analytic.username || 'N/A' }}</td>
                  <td @click="goToCategories(analytic.id, analytic.userId)">{{ formatDate(analytic.analysisAt) }}</td>
                  <td @click="goToCategories(analytic.id, analytic.userId)">{{ analytic.notes || 'Sin notas' }}</td>
                  <td class="action-cell" v-has-feature="'Superadmin'">
                    <button class="report-btn" @click.stop="goToImportReport(analytic.id)">Informe</button>
                  </td>
                  <td class="action-cell">
                    <button class="categories-btn" @click.stop="goToCategories(analytic.id, analytic.userId)">Resultados</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="analytics.length === 0" class="no-data">
              {{ $t('health.analytics.list.empty') }}            </div>
          </div>
        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<style scoped lang="scss">
.analytics-list {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.analytics-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }

  th {
    background-color: #fafafa;
    color: #555;
    font-weight: bold;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9f9f9;
    }
  }

  .icon-cell {
    text-align: right;
    color: #888;
    width: 40px;
  }

  .action-cell, .action-header {
    text-align: center;
    width: 100px;
  }

  .report-btn, .categories-btn {
    padding: 5px 14px;
    border-radius: 4px;
    background: #ffffff;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s;
  }

  .report-btn {
    border: 1px solid #4472C4;
    color: #4472C4;

    &:hover {
      background: #4472C4;
      color: #ffffff;
    }
  }

  .categories-btn {
    border: 1px solid #28a745;
    color: #28a745;

    &:hover {
      background: #28a745;
      color: #ffffff;
    }
  }
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/analytics/AnalyticsList.vue